export default __webpack_public_path__ + "static/media/logo-desktop-nav-ec0f69.b89c21ea.svg";